<template>
  <div class="customer-detail-view">
    <!-- En-tête -->
    <div class="page-header">
      <button @click="$router.push({ name: 'customers' })" class="back-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Retour
      </button>
      <div class="header-actions">
        <button @click="sendSMS" class="action-btn secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          SMS
        </button>
        <button @click="sendEmail" class="action-btn secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          Email
        </button>
        <button @click="editCustomer" class="action-btn primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
          </svg>
          Modifier
        </button>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="loading-container">
      <div class="spinner"></div>
      <p>Chargement...</p>
    </div>

    <!-- Message d'erreur -->
    <div v-else-if="!loading && !customer.id" class="not-found-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.5">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h2>Client introuvable</h2>
      <p>Le client que vous recherchez n'existe pas.</p>
      <button @click="$router.push({ name: 'customers' })" class="action-btn primary">
        Retour aux clients
      </button>
    </div>

    <!-- Contenu -->
    <div v-else class="customer-content">
      <!-- Colonne gauche -->
      <div class="left-column">
        <!-- Carte profil -->
        <div class="profile-card">
          <div class="profile-header">
            <div class="avatar">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div class="profile-info">
              <h1 class="customer-name">{{ customer.name }}</h1>
              <p class="member-since">Membre depuis {{ formatDate(customer.created_at) }}</p>
            </div>
          </div>

          <div class="contact-section">
            <div v-if="customer.phone" class="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                </path>
              </svg>
              <span>{{ customer.phone }}</span>
            </div>
            <div v-if="customer.email" class="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22 6 12 13 2 6"></polyline>
              </svg>
              <span>{{ customer.email }}</span>
            </div>
            <div v-if="customer.full_address" class="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{{ customer.full_address }}</span>
            </div>
          </div>
        </div>

        <!-- Stats -->
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-icon blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
            </div>
            <div class="stat-details">
              <span class="stat-value">{{ customer.sales_count || 0 }}</span>
              <span class="stat-label">Ventes</span>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon green">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
            </div>
            <div class="stat-details">
              <span class="stat-value">{{ formatCurrency(customer.total_spent || 0) }}</span>
              <span class="stat-label">Total payé</span>
            </div>
          </div>

          <div class="stat-card" :class="{ warning: customer.total_unpaid > 0 }">
            <div class="stat-icon" :class="customer.total_unpaid > 0 ? 'orange' : 'gray'">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div class="stat-details">
              <span class="stat-value">{{ formatCurrency(customer.total_unpaid || 0) }}</span>
              <span class="stat-label">{{ customer.unpaid_sales_count || 0 }} impayée(s)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Colonne droite: Ventes -->
      <div class="right-column">
        <div class="sales-card">
          <div class="sales-header">
            <h2>Historique des ventes</h2>
            <div class="sales-filters">
              <button :class="['filter-btn', { active: salesFilter === 'all' }]" @click="setSalesFilter('all')">
                Toutes
              </button>
              <button :class="['filter-btn', { active: salesFilter === 'paid' }]" @click="setSalesFilter('paid')">
                Payées
              </button>
              <button :class="['filter-btn', { active: salesFilter === 'unpaid' }]" @click="setSalesFilter('unpaid')">
                Impayées ({{ customer.unpaid_sales_count || 0 }})
              </button>
            </div>
          </div>

          <!-- Actions en lot pour impayées -->
          <div v-if="salesFilter === 'unpaid' && unpaidSales.length > 0" class="bulk-actions">
            <button v-if="selectedSales.length === 0" @click="selectAllUnpaid" class="action-btn secondary small">
              Tout sélectionner
            </button>
            <button v-if="selectedSales.length > 0" @click="clearSelection" class="action-btn secondary small">
              Désélectionner ({{ selectedSales.length }})
            </button>
            <button v-if="selectedSales.length > 0" @click="openPaymentModal" class="action-btn primary small">
              Encaisser {{ formatCurrency(selectedTotal) }}
            </button>
          </div>

          <!-- Loader -->
          <div v-if="salesLoading" class="sales-loading">
            <div class="spinner-small"></div>
            <p>Chargement...</p>
          </div>

          <!-- Empty -->
          <div v-else-if="filteredSales.length === 0" class="no-sales">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5">
              <path d="M3 3h18v18H3zM8 12h8M8 8h8M8 16h4"></path>
            </svg>
            <h3>Aucune vente {{ getSalesFilterLabel() }}</h3>
          </div>

          <!-- Liste -->
          <div v-else class="sales-list">
            <div v-for="sale in filteredSales" :key="sale.id" class="sale-item"
              :class="{ selected: isSelected(sale.id) }">
              <div class="sale-checkbox" v-if="salesFilter === 'unpaid'">
                <input type="checkbox" :checked="isSelected(sale.id)" @change="toggleSaleSelection(sale)">
              </div>
              <div class="sale-content" @click="viewSale(sale)">
                <div class="sale-header-row">
                  <span class="invoice-number">{{ sale.invoice_number }}</span>
                  <span class="status-badge" :class="getStatusClass(sale.status)">
                    {{ getStatusLabel(sale.status) }}
                  </span>
                </div>
                <div class="sale-details-row">
                  <span class="sale-date">{{ formatDate(sale.sale_date) }}</span>
                  <span class="sale-amount">{{ formatCurrency(sale.total_incl_tax) }}</span>
                </div>
              </div>
              <div class="sale-actions">
                <button v-if="sale.status === 'pending'" @click.stop="paySingleSale(sale)" class="pay-btn"
                  title="Encaisser">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                    <circle cx="12" cy="12" r="2"></circle>
                  </svg>
                </button>
                <button @click.stop="viewSale(sale)" class="view-btn" title="Voir">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal paiement -->
    <div v-if="showPaymentModal" class="modal-overlay" @click.self="closePaymentModal">
      <div class="modal-container">
        <div class="modal-header">
          <h2>{{ isMultiplePayment ? 'Encaissement en lot' : 'Encaisser la facture' }}</h2>
          <button @click="closePaymentModal" class="close-btn">×</button>
        </div>

        <div class="modal-body">
          <!-- Factures -->
          <div class="payment-summary">
            <h3>{{ isMultiplePayment ? 'Factures sélectionnées' : 'Facture' }}</h3>
            <div class="selected-sales">
              <div v-for="sale in salesToPay" :key="sale.id" class="selected-sale">
                <div>
                  <span class="invoice">{{ sale.invoice_number }}</span>
                  <span class="date">{{ formatDate(sale.sale_date) }}</span>
                </div>
                <span class="amount">{{ formatCurrency(sale.total_incl_tax) }}</span>
              </div>
            </div>
            <div class="total-row">
              <span>Total à encaisser</span>
              <span class="total">{{ formatCurrency(paymentTotal) }}</span>
            </div>
          </div>

          <!-- Méthode -->
          <div class="payment-methods">
            <h3>Méthode de paiement</h3>
            <div class="methods-grid">
              <button v-for="method in paymentMethods" :key="method.id"
                :class="['method-btn', { active: selectedPaymentMethod === method.id }]"
                @click="selectPaymentMethod(method.id)">
                <span class="method-icon">{{ method.icon }}</span>
                <span class="method-name">{{ method.name }}</span>
              </button>
            </div>
          </div>

          <!-- Notes -->
          <div class="form-group">
            <label>Notes (optionnel)</label>
            <textarea v-model="paymentNotes" placeholder="Notes..." rows="3"></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="closePaymentModal" class="action-btn secondary">Annuler</button>
          <button @click="confirmPayment" class="action-btn primary" :disabled="!canConfirmPayment || isProcessing">
            <span v-if="isProcessing" class="spinner-small"></span>
            {{ isProcessing ? 'Traitement...' : 'Confirmer' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import customerService from '@/services/customerService';
import paymentService from '@/services/paymentService';

export default defineComponent({
  name: 'CustomerDetail',
  setup() {
    const route = useRoute();
    const router = useRouter();

    const customer = ref({});
    const sales = ref([]);
    const loading = ref(true);
    const salesLoading = ref(false);
    const salesFilter = ref('all');
    const selectedSales = ref([]);
    const showPaymentModal = ref(false);
    const selectedPaymentMethod = ref('');
    const paymentNotes = ref('');
    const isProcessing = ref(false);

    const paymentMethods = [
      { id: 'cash', name: 'Espèces', icon: '💵' },
      { id: 'card', name: 'Carte', icon: '💳' },
      { id: 'wave', name: 'Mobile Money', icon: '📱' },
      { id: 'bank_transfer', name: 'Virement', icon: '🏦' }
    ];

    const filteredSales = computed(() => {
      if (salesFilter.value === 'paid') {
        return sales.value.filter(sale => sale.status === 'completed');
      }
      if (salesFilter.value === 'unpaid') {
        return sales.value.filter(sale => sale.status === 'pending');
      }
      return sales.value;
    });

    const unpaidSales = computed(() => {
      return sales.value.filter(sale => sale.status === 'pending');
    });

    const selectedTotal = computed(() => {
      return selectedSales.value.reduce((total, sale) => total + sale.total_incl_tax, 0);
    });

    const isMultiplePayment = computed(() => selectedSales.value.length > 1);
    const salesToPay = computed(() => selectedSales.value);
    const paymentTotal = computed(() => selectedTotal.value);
    const canConfirmPayment = computed(() => selectedPaymentMethod.value && selectedSales.value.length > 0);

    const loadCustomerDetails = async () => {
      const customerId = route.params.id;
      if (!customerId) {
        router.push({ name: 'customers' });
        return;
      }

      try {
        loading.value = true;
        const response = await customerService.getCustomer(customerId);
        customer.value = response.data.customer || response.data;
        await loadCustomerSales();
      } catch (error) {
        console.error('Erreur:', error);
        customer.value = {};
      } finally {
        loading.value = false;
      }
    };

    const loadCustomerSales = async () => {
      try {
        salesLoading.value = true;
        const response = await customerService.getCustomerSales(customer.value.id, {
          with: ['saleItems.product', 'payment']
        });
        sales.value = response.data.sales || [];
      } catch (error) {
        console.error('Erreur:', error);
        sales.value = [];
      } finally {
        salesLoading.value = false;
      }
    };

    const setSalesFilter = (filter) => {
      salesFilter.value = filter;
      clearSelection();
    };

    const getSalesFilterLabel = () => {
      const labels = { 'all': '', 'paid': 'payée', 'unpaid': 'impayée' };
      return labels[salesFilter.value] || '';
    };

    const editCustomer = () => {
      console.log('TODO: Modifier le client', customer.value.id);
      router.push({ name: 'customer-edit', params: { id: customer.value.id } });
    };

    const sendSMS = () => {
      console.log('TODO: Envoyer SMS au client', customer.value.id);
    };

    const sendEmail = () => {
      console.log('TODO: Envoyer Email au client', customer.value.id);
    };

    const viewSale = (sale) => {
      router.push({ name: 'sale-details', params: { id: sale.id } });
    };

    const isSelected = (saleId) => {
      return selectedSales.value.some(sale => sale.id === saleId);
    };

    const toggleSaleSelection = (sale) => {
      const index = selectedSales.value.findIndex(s => s.id === sale.id);
      if (index > -1) {
        selectedSales.value.splice(index, 1);
      } else {
        selectedSales.value.push(sale);
      }
    };

    const selectAllUnpaid = () => {
      selectedSales.value = [...unpaidSales.value];
    };

    const clearSelection = () => {
      selectedSales.value = [];
    };

    const paySingleSale = (sale) => {
      selectedSales.value = [sale];
      openPaymentModal();
    };

    const openPaymentModal = () => {
      if (selectedSales.value.length === 0) return;
      showPaymentModal.value = true;
    };

    const closePaymentModal = () => {
      showPaymentModal.value = false;
      selectedPaymentMethod.value = '';
      paymentNotes.value = '';
    };

    const selectPaymentMethod = (methodId) => {
      selectedPaymentMethod.value = methodId;
    };

    const confirmPayment = async () => {
      if (!canConfirmPayment.value) return;

      try {
        isProcessing.value = true;
        console.log('TODO: Traiter le paiement', {
          isMultiple: isMultiplePayment.value,
          sales: selectedSales.value,
          method: selectedPaymentMethod.value,
          notes: paymentNotes.value
        });

        if (isMultiplePayment.value) {
          const bulkData = paymentService.prepareBulkPaymentData(
            customer.value.id,
            selectedPaymentMethod.value,
            selectedSales.value.map(sale => ({ saleId: sale.id, amount: sale.total_incl_tax })),
            { notes: paymentNotes.value }
          );
          await paymentService.bulkPayments(bulkData);
        } else {
          const sale = selectedSales.value[0];
          const paymentData = paymentService.prepareSinglePaymentData(
            sale.id,
            selectedPaymentMethod.value,
            sale.total_incl_tax,
            { notes: paymentNotes.value }
          );
          await paymentService.makePayment(paymentData);
        }

        closePaymentModal();
        clearSelection();
        await loadCustomerDetails();
      } catch (error) {
        console.error('Erreur paiement:', error);
      } finally {
        isProcessing.value = false;
      }
    };

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XOF',
        minimumFractionDigits: 0
      }).format(amount || 0);
    };

    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    };

    const getStatusLabel = (status) => {
      const labels = {
        'pending': 'En attente',
        'completed': 'Payée',
        'refunded': 'Remboursée',
        'partial_refund': 'Remb. partiel'
      };
      return labels[status] || status;
    };

    const getStatusClass = (status) => {
      const classes = {
        'pending': 'status-pending',
        'completed': 'status-completed',
        'refunded': 'status-refunded',
        'partial_refund': 'status-partial'
      };
      return classes[status] || '';
    };

    onMounted(() => {
      loadCustomerDetails();
    });

    return {
      customer,
      sales,
      loading,
      salesLoading,
      salesFilter,
      selectedSales,
      showPaymentModal,
      selectedPaymentMethod,
      paymentNotes,
      isProcessing,
      paymentMethods,
      filteredSales,
      unpaidSales,
      selectedTotal,
      isMultiplePayment,
      salesToPay,
      paymentTotal,
      canConfirmPayment,
      setSalesFilter,
      getSalesFilterLabel,
      isSelected,
      toggleSaleSelection,
      selectAllUnpaid,
      clearSelection,
      paySingleSale,
      openPaymentModal,
      closePaymentModal,
      selectPaymentMethod,
      confirmPayment,
      editCustomer,
      sendSMS,
      sendEmail,
      viewSale,
      formatCurrency,
      formatDate,
      getStatusLabel,
      getStatusClass
    };
  }
});
</script>

<style scoped>
.customer-detail-view {
  padding: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-btn:hover {
  background: #f9fafb;
}

.header-actions {
  display: flex;
  gap: 0.75rem;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.action-btn.primary {
  background: #0A5C6B;
  color: white;
}

.action-btn.primary:hover {
  background: #094854;
}

.action-btn.secondary {
  background: white;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.action-btn.secondary:hover {
  background: #f9fafb;
}

.action-btn.small {
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
}

.loading-container,
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 12px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #0A5C6B;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.customer-content {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 1.5rem;
}

.left-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.profile-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  flex-shrink: 0;
}

.profile-info {
  flex: 1;
}

.customer-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.25rem 0;
}

.member-since {
  font-size: 0.8rem;
  color: #6b7280;
  margin: 0;
}

.contact-section {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.stat-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stat-card.warning {
  background: #fffbeb;
  border: 1px solid #fcd34d;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon.blue {
  background: #dbeafe;
  color: #1e40af;
}

.stat-icon.green {
  background: #d1fae5;
  color: #065f46;
}

.stat-icon.orange {
  background: #fed7aa;
  color: #c2410c;
}

.stat-icon.gray {
  background: #f3f4f6;
  color: #6b7280;
}

.stat-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
}

.stat-label {
  font-size: 0.75rem;
  color: #6b7280;
}

.right-column {
  display: flex;
  flex-direction: column;
}

.sales-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: fit-content;
}

.sales-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.sales-header h2 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.sales-filters {
  display: flex;
  gap: 0.5rem;
}

.filter-btn {
  padding: 0.5rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  color: #6b7280;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-btn:hover {
  background: #f9fafb;
}

.filter-btn.active {
  background: #0A5C6B;
  color: white;
  border-color: #0A5C6B;
}

.bulk-actions {
  display: flex;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f3f4f6;
  background: #f9fafb;
}

.sales-loading,
.no-sales {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  color: #6b7280;
}

.sales-list {
  display: flex;
  flex-direction: column;
}

.sale-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s;
}

.sale-item:hover {
  background: #f9fafb;
}

.sale-item.selected {
  background: #f0fdfa;
  border-left: 3px solid #0A5C6B;
}

.sale-checkbox {
  display: flex;
  align-items: center;
}

.sale-checkbox input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.sale-content {
  flex: 1;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sale-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.invoice-number {
  font-family: monospace;
  font-weight: 600;
  color: #111827;
  font-size: 0.9rem;
}

.status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-pending {
  background: #fef3c7;
  color: #92400e;
}

.status-completed {
  background: #d1fae5;
  color: #065f46;
}

.status-refunded {
  background: #fee2e2;
  color: #991b1b;
}

.sale-details-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sale-date {
  font-size: 0.8rem;
  color: #6b7280;
}

.sale-amount {
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
}

.sale-actions {
  display: flex;
  gap: 0.5rem;
}

.pay-btn,
.view-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  background: white;
}

.pay-btn {
  color: #059669;
  border-color: #d1fae5;
}

.pay-btn:hover {
  background: #f0fdf4;
}

.view-btn {
  color: #6b7280;
  border-color: #e5e7eb;
}

.view-btn:hover {
  background: #f9fafb;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-container {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.close-btn:hover {
  background: #f3f4f6;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
}

.payment-summary,
.payment-methods {
  margin-bottom: 1.5rem;
}

.payment-summary h3,
.payment-methods h3 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 1rem 0;
}

.selected-sales {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  max-height: 200px;
  overflow-y: auto;
}

.selected-sale {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e5e7eb;
}

.selected-sale:last-child {
  border-bottom: none;
}

.invoice {
  font-family: monospace;
  font-weight: 600;
  display: block;
  font-size: 0.85rem;
}

.date {
  font-size: 0.75rem;
  color: #6b7280;
  display: block;
}

.amount {
  font-weight: 600;
  font-size: 0.9rem;
}

.total-row {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;
  background: #f3f4f6;
  border-radius: 6px;
  font-weight: 600;
}

.total {
  color: #0A5C6B;
  font-size: 1.1rem;
}

.methods-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.method-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.method-btn:hover {
  background: #f9fafb;
}

.method-btn.active {
  border-color: #0A5C6B;
  background: #f0fdfa;
}

.method-icon {
  font-size: 1.5rem;
}

.method-name {
  font-size: 0.8rem;
  font-weight: 500;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.form-group textarea {
  width: 100%;
  padding: 0.625rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.9rem;
  resize: vertical;
}

.form-group textarea:focus {
  outline: none;
  border-color: #0A5C6B;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

@media (max-width: 1024px) {
  .customer-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 1rem;
  }

  .header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .sales-header {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>